import Immutable, { List, Record, Set } from 'immutable';

export interface IPollChoice {
  id: string;
  value: string;
  respondents: Set<any>;
}

// @ts-ignore
export const PollChoice: Record.Factory<IPollChoice> = Record(
  {
    id: null,
    value: null,
    respondents: Set(),
  },
  'PollChoice'
);

/* eslint-disable no-unused-vars */
export enum PollQuestionType {
  MultipleChoice = 100,
  NumberScale = 200,
  StarRating = 300,
  CustomerSatisfaction = 400,
}

export enum PollSelectionType {
  Single = 'single',
  Multiple = 'multiple',
}
/* eslint-enable no-unused-vars */

export interface IPollQuestion {
  type: 'poll';
  id: string;
  name: string;
  question_type: PollQuestionType;
  selection_type: PollSelectionType;
  low_label?: string;
  high_label?: string;
  tell_us_more_enabled: boolean;
  tell_us_more_placeholder: string;
  tell_us_more: string;
  choices: List<IPollChoice>;
}

// @ts-ignore
export const PollQuestion: Record.Factory<IPollQuestion> = Record(
  {
    type: 'poll',
    id: null,
    name: null,
    question_type: PollQuestionType.MultipleChoice,
    selection_type: PollSelectionType.Single,
    low_label: null,
    high_label: null,
    tell_us_more_enabled: false,
    tell_us_more_placeholder: '',
    tell_us_more: '',
    choices: List(),
  },
  'PollQuestion'
);

export interface IPollRespondent {
  id: string;
  type: any;
  name: string;
  avatar: string;
  color: string;
}

// @ts-ignore
export const PollRespondent: Record.Factory<IPollRespondent> = Record({
  id: null,
  type: null,
  name: null,
  avatar: null,
  color: null,
});

export function toPollQuestion(data: any): IPollQuestion {
  if (data instanceof PollQuestion) return data;

  data = Immutable.fromJS(data);
  return new PollQuestion(data).set(
    'choices',
    data
      .get('choices')
      .map((choice: any) =>
        typeof choice === 'string'
          ? new PollChoice({ value: choice })
          : new PollChoice(choice)
      )
      .toList()
  );
}
